import React from 'react';
import clx from 'classnames';
import './ContainerFront.scss';

export interface ContainerFrontProps {
  children: React.ReactNode;
  dark?: boolean;
  isHeader?: boolean;
  isFooter?: boolean;
  isContent?: boolean;
  className?: string;
}

/**
 * Container delle pagine pubbliche
 * Definisce la larghezza massima del contenuto della pagina.
 */
export function ContainerFront(props: ContainerFrontProps) {
  return (
    <div
      className={clx('container-front', props.className, {
        'dark-theme': props.dark,
        'is-header': props.isHeader,
        'is-footer': props.isFooter,
        'is-content': props.isContent
      })}
    >
      <div className={clx('content', {})}>{props.children}</div>
    </div>
  );
}
